import React from 'react'
import { Modal } from 'semantic-ui-react'
import { AppSecondaryButton } from 'elements'
import styled from 'styled-components'

const DangerBtn = styled.button`
    background: #dc2626;
    color: #fff;
    border: 1px solid #dc2626;
    padding: 7px 14px;
    border-radius: 6px;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;

    &:hover {
        background: #b91c1c;
    }

    &:disabled {
        background: #fca5a5;
        border-color: #fca5a5;
        cursor: not-allowed;
    }
`

const ModalIcon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fee2e2;
    color: #dc2626;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 8px;
`

const ModalTitle = styled.h3`
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
`

const ModalSubtitle = styled.p`
    color: #6b7280;
    font-size: 12px;
    margin: 0 0 10px;
    line-height: 1.45;
`

const ImpactBox = styled.div`
    background: #fafbfc;
    border-radius: 6px;
    padding: 10px 12px;
    margin: 0 0 10px;
    font-size: 12px;
    color: #4b5563;
    line-height: 1.5;
    text-align: left;
`

const CompactModal = styled(Modal)`
    &.ui.modal {
        width: 400px;
        max-width: calc(100vw - 2rem);
    }

    > .content {
        padding: 16px 18px 12px !important;
    }

    > .actions {
        padding: 10px 14px 14px !important;
    }
`

export const RollbackMigrationModal = ({
    open,
    entry,
    saving,
    onClose,
    onConfirm,
}) => {
    if (!entry) return null

    return (
        <CompactModal open={open} onClose={onClose} size="mini">
            <Modal.Content style={{ textAlign: 'center' }}>
                <ModalIcon>↺</ModalIcon>
                <ModalTitle>
                    Roll back &quot;{entry.masterListName}&quot;?
                </ModalTitle>
                <ModalSubtitle>
                    This is reversible — but it does write to the database.
                    Make sure no users are mid-edit on these templates.
                </ModalSubtitle>
                <ImpactBox>
                    This will <strong>NULL the MasterListId</strong> on{' '}
                    <strong>{entry.questionsUpdated}</strong> template
                    question
                    {entry.questionsUpdated === 1 ? '' : 's'}, then{' '}
                    <strong>soft-delete</strong> the master list &quot;
                    <strong>{entry.masterListName}</strong>&quot; and its{' '}
                    <strong>{entry.itemsInserted}</strong> item
                    {entry.itemsInserted === 1 ? '' : 's'}.
                    <br />
                    <span style={{ color: '#10b981', fontSize: 11.5 }}>
                        ✓ In-progress audits are unaffected — they keep their
                        frozen text from when &quot;Start Inspection&quot; ran.
                    </span>
                </ImpactBox>
            </Modal.Content>
            <Modal.Actions>
                <AppSecondaryButton type="button" onClick={onClose}>
                    Cancel
                </AppSecondaryButton>
                <DangerBtn
                    type="button"
                    disabled={saving}
                    onClick={onConfirm}
                >
                    Yes, roll back
                </DangerBtn>
            </Modal.Actions>
        </CompactModal>
    )
}
